import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { GoingUpIllustration } from './GoingUp';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const GoingUp = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <GoingUpIllustration title={title} />
  </IllustrationWrapper>
);
